import React from 'react';
import times from 'lodash/times';
import { Card } from '../../../../../CommonComponents/OPL/Card/Card';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../../../../../CommonComponents/OPL/Shimmer/Shimmer';
import { HtmlTable } from '../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { useIsEmbeddedMobile } from '../../../../../_hooks/useIsEmbeddedMobile';

export const RealizedGainLossTabLoading = () => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  const mobileBorderLayout = {
    bordeTop: '1px solid',
    borderBottom: '1px solid',
    borderColor: 'neutral.200',
  };

  const dektopBorderLayout = {
    borderLeft: '1px solid',
    borderRight: '1px solid',
    borderColor: 'neutral.200',
  };

  return (
    <>
      <Box mb="24" {...(isEmbeddedMobile ? { mt: '24' } : {})}>
        <Card hasBorder boxShadow="none" {...(isEmbeddedMobile ? { borderRadius: 'none' } : {})}>
          <Box display="flex" {...(isEmbeddedMobile ? { flexDirection: 'column' } : {})}>
            {times(3).map((key, index) => (
              <Box
                key={key}
                p="24"
                display="flex"
                flexDirection="column"
                flex={1}
                {...(index === 1
                  ? isEmbeddedMobile
                    ? mobileBorderLayout
                    : dektopBorderLayout
                  : {})}
              >
                <Shimmer
                  width="100%"
                  mb="4"
                  {...(isEmbeddedMobile ? { height: '12px' } : { height: '16px' })}
                />

                <Shimmer
                  width="100%"
                  {...(isEmbeddedMobile ? { height: '20px' } : { height: '48px' })}
                />
              </Box>
            ))}
          </Box>
        </Card>
      </Box>

      {isEmbeddedMobile ? (
        <HtmlTable>
          <table>
            <caption>
              <Box display="flex" justifyContent="space-between">
                <Shimmer width="150px" height="24px" />

                <Shimmer width="100px" height="24px" />
              </Box>
            </caption>

            <thead>
              <tr>
                {times(2).map(key => (
                  <th key={key}>
                    <Shimmer width="100%" height="16px" />
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              <tr>
                {times(2).map(key => (
                  <td key={key}>
                    <Shimmer width="100%" height="16px" />
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </HtmlTable>
      ) : (
        <HtmlTable>
          <table>
            <caption>
              <Box display="flex" justifyContent="space-between">
                <Shimmer width="150px" height="24px" />

                <Shimmer width="100px" height="24px" />
              </Box>
            </caption>

            <thead>
              <tr>
                {times(4).map(key => (
                  <th key={key}>
                    <Shimmer width="100%" height="16px" />
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              <tr>
                {times(4).map(key => (
                  <td key={key}>
                    <Shimmer width="100%" height="16px" />
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </HtmlTable>
      )}
    </>
  );
};
